// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flow-step-list-item {
  background-color: rgb(var(--color-surface-dark));
}
[data-depth="1"] > .flow-step-item-section > .flow-step-list-item,
[data-depth="3"] > .flow-step-item-section > .flow-step-list-item {
  background-color: rgb(var(--color-surface-dark));
}
[data-depth="2"] > .flow-step-item-section > .flow-step-list-item,
[data-depth="4"] > .flow-step-item-section > .flow-step-list-item {
  background-color: #ffffff;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
